import * as actions from './actions';

const initialState = {
    error: null,
    banners: [],
    loading: false,
    initialUIElements: false
};




export default function uielementsReducer(state = initialState, action) {
    switch (action.type) {
        // fetch
        case actions.FETCH_BANNERS.REQUEST:
            return { ...state, error: null, loading: true };

        case actions.FETCH_BANNERS.SUCCESS: {
            return { ...state, initialUIElements: true, banners: action.payload, loading: false };
        }
        case actions.FETCH_BANNERS.FAILURE:
            return { ...state, initialUIElements: false, error: action.payload, loading: false };

        default:
            return state;
    }
}